<template>
  <div class="menu-management">
    <!-- Header -->
    <div class="page-header">
      <div class="header-content">
        <h1 class="page-title">
          <i class="el-icon-menu"></i>
          Manajemen Menu
        </h1>
        <p class="page-subtitle">Kelola menu navigasi aplikasi</p>
      </div>
      <el-button type="primary" @click="showCreateModal" icon="el-icon-plus">
        Tambah Menu
      </el-button>
    </div>

    <!-- Search and Filters -->
    <div class="search-section">
      <div class="search-controls">
        <el-input
          v-model="searchQuery"
          placeholder="Cari menu..."
          prefix-icon="el-icon-search"
          clearable
          class="search-input"
          @input="handleSearch"
        />
        <el-select v-model="statusFilter" placeholder="Filter Status" clearable class="filter-select">
          <el-option label="Semua Status" value=""></el-option>
          <el-option label="Aktif" value="active"></el-option>
          <el-option label="Tidak Aktif" value="inactive"></el-option>
          <el-option label="Dihapus" value="deleted"></el-option>
        </el-select>
        <el-button @click="resetFilters" icon="el-icon-refresh">Reset</el-button>
      </div>
    </div>

    <!-- Data Table -->
    <div class="table-section">
      <el-table 
        :data="filteredMenus" 
        v-loading="loading"
        stripe
        border
        style="width: 100%"
        @sort-change="handleSort"
      >
        <el-table-column 
          prop="id" 
          label="ID" 
          width="80"
          sortable
        />
        
        <el-table-column 
          prop="name" 
          label="Name" 
          min-width="120"
          sortable
        />
        
        <el-table-column 
          prop="label" 
          label="Label" 
          min-width="120"
          sortable
        />
        
        <el-table-column 
          prop="path" 
          label="Path" 
          min-width="150"
          show-overflow-tooltip
        />
        
        <el-table-column 
          prop="icon" 
          label="Icon" 
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <!-- Check if icon is a class (el-icon-*) or image URL -->
            <i v-if="scope.row.icon && scope.row.icon.startsWith('el-icon-')" 
               :class="scope.row.icon" 
               style="font-size: 18px;">
            </i>
            <img v-else-if="scope.row.icon" 
                 :src="scope.row.icon" 
                 :alt="scope.row.label"
                 style="width: 24px; height: 24px; object-fit: contain;"
                 @error="handleIconError"
            />
            <i v-else class="el-icon-menu" style="font-size: 18px; color: #999;"></i>
          </template>
        </el-table-column>
        
        <el-table-column 
          prop="is_actived" 
          label="Status" 
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <!-- <el-tag 
              :type="scope.row.is_actived ? 'success' : 'danger'"
              size="small"
            >
              {{ scope.row.is_actived ? 'Aktif' : 'Tidak Aktif' }}
            </el-tag> -->
             <p class="text-xs p-0 m-0" :class="scope.row.is_actived ? 'text-green-500' : 'text-red-500'">{{ scope.row.is_actived ? 'Aktif' : 'Tidak Aktif' }}</p>
          </template>
        </el-table-column>
        
        <!-- <el-table-column 
          prop="is_deleted" 
          label="Deleted" 
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag 
              :type="scope.row.is_deleted ? 'warning' : 'info'"
              size="small"
            >
              {{ scope.row.is_deleted ? 'Ya' : 'Tidak' }}
            </el-tag>
          </template>
        </el-table-column> -->
        
        <!-- <el-table-column 
          prop="created_at" 
          label="Dibuat" 
          width="120"
          sortable
        >
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column> -->
        
        <!-- <el-table-column 
          prop="code" 
          label="Code" 
          width="120"
          show-overflow-tooltip
        /> -->
        
        <el-table-column 
          label="Aksi" 
          width="180"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="flex space-x-2">
              <el-button 
                size="mini" 
                @click="showEditModal(scope.row)"
                icon="el-icon-edit"
              >
                Edit
              </el-button>
              <el-button 
                size="mini" 
                type="danger" 
                @click="confirmDelete(scope.row)"
                icon="el-icon-delete"
              >
                Hapus
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        />
      </div>
    </div>

    <!-- Create/Edit Modal -->
    <el-dialog 
      :title="isEditing ? 'Edit Menu' : 'Tambah Menu Baru'"
      :visible.sync="showModal"
      width="600px"
      @close="resetForm"
    >
      <el-form 
        :model="menuForm" 
        :rules="formRules" 
        ref="menuForm"
        label-width="120px"
      >
        <el-form-item label="Name" prop="name">
          <el-input v-model="menuForm.name" placeholder="Masukkan nama menu" />
        </el-form-item>
        
        <el-form-item label="Label" prop="label">
          <el-input v-model="menuForm.label" placeholder="Masukkan label menu" />
        </el-form-item>
        
        <el-form-item label="Path" prop="path">
          <el-input v-model="menuForm.path" placeholder="/path/to/route" />
        </el-form-item>
        
        <el-form-item label="Icon" prop="icon">
          <div class="icon-uploader">
            <div v-if="iconPreview" class="icon-preview">
              <img :src="iconPreview" />
            </div>
            <el-upload
              ref="iconUpload"
              action=""
              :show-file-list="false"
              :on-change="handleIconChange"
              :auto-upload="false"
              accept="image/*"
            >
              <el-button size="small" type="primary">
                <i class="el-icon-upload"></i>
                {{ iconPreview ? 'Ganti Icon' : 'Pilih Icon' }}
              </el-button>
              <div slot="tip" class="el-upload__tip">
                Upload file icon (JPG, PNG, max 2MB)
              </div>
            </el-upload>
          </div>
        </el-form-item>
        
        <el-form-item label="Status">
          <el-switch
            v-model="menuForm.is_actived"
            active-text="Aktif"
            inactive-text="Tidak Aktif"
          />
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="showModal = false">Batal</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">
          {{ isEditing ? 'Update' : 'Simpan' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MenuManagementHome',
  data() {
    return {
      // UI State
      loading: false,
      submitting: false,
      showModal: false,
      isEditing: false,
      
      // Search & Filter
      searchQuery: '',
      statusFilter: '',
      
      // Pagination
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      
      // Form Data
      menuForm: {
        id: null,
        name: '',
        label: '',
        path: '',
        icon: '',
        is_actived: true,
        is_deleted: false,
        code: ''
      },
      
      // Icon upload
      iconFile: null,
      iconPreview: '',
      
      // Validation Rules
      formRules: {
        name: [
          { required: true, message: 'Nama menu wajib diisi', trigger: 'blur' },
          { min: 3, max: 50, message: 'Nama harus 3-50 karakter', trigger: 'blur' }
        ],
        label: [
          { required: true, message: 'Label menu wajib diisi', trigger: 'blur' },
          { min: 3, max: 50, message: 'Label harus 3-50 karakter', trigger: 'blur' }
        ],
        path: [
          { required: true, message: 'Path menu wajib diisi', trigger: 'blur' },
          { pattern: /^\/.*/, message: 'Path harus dimulai dengan /', trigger: 'blur' }
        ]
      },
      
      // Icon Options
      iconOptions: [
        { value: 'el-icon-menu', label: 'Menu' },
        { value: 'el-icon-house', label: 'Home' },
        { value: 'el-icon-user', label: 'User' },
        { value: 'el-icon-setting', label: 'Settings' },
        { value: 'el-icon-document', label: 'Document' },
        { value: 'el-icon-folder', label: 'Folder' },
        { value: 'el-icon-s-data', label: 'Data' },
        { value: 'el-icon-s-tools', label: 'Tools' },
        { value: 'el-icon-s-help', label: 'Help' },
        { value: 'el-icon-s-flag', label: 'Flag' },
        { value: 'el-icon-pie-chart', label: 'Chart' },
        { value: 'el-icon-bell', label: 'Notification' },
        { value: 'el-icon-message', label: 'Message' },
        { value: 'el-icon-phone', label: 'Phone' },
        { value: 'el-icon-location', label: 'Location' }
      ],
      
      // Data from API (will be populated on mount)
      menus: []
    }
  },
  computed: {
    filteredMenus() {
      let filtered = this.menus
      
      // Search filter
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase()
        filtered = filtered.filter(menu => 
          menu.name.toLowerCase().includes(query) ||
          menu.label.toLowerCase().includes(query) ||
          menu.path.toLowerCase().includes(query)
        )
      }
      
      // Status filter
      if (this.statusFilter) {
        if (this.statusFilter === 'active') {
          filtered = filtered.filter(menu => menu.is_actived && !menu.is_deleted)
        } else if (this.statusFilter === 'inactive') {
          filtered = filtered.filter(menu => !menu.is_actived && !menu.is_deleted)
        } else if (this.statusFilter === 'deleted') {
          filtered = filtered.filter(menu => menu.is_deleted)
        }
      }
      
      this.totalItems = filtered.length
      
      // Pagination
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return filtered.slice(start, end)
    }
  },
  mounted() {
    this.loadMenus()
  },
  beforeDestroy() {
    // Cleanup blob URLs to prevent memory leaks
    this.menus.forEach(menu => {
      if (menu.icon && menu.icon.startsWith('blob:')) {
        URL.revokeObjectURL(menu.icon)
      }
    })
  },
  methods: {
    // Get Token from localStorage
    getAuthToken() {
      // Sesuaikan dengan cara penyimpanan token di aplikasi Anda
      return localStorage.getItem('token') || sessionStorage.getItem('token') || ''
    },
    
    // Data Loading
    async loadMenus() {
      this.loading = true
      try {
        const token = this.getAuthToken()
        const response = await fetch('https://apidev-intranet.lan.go.id/api/menu', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const result = await response.json()
        
        if (result.status === 200 && result.data) {
          // Map API response to match component data structure
          const menusData = await Promise.all(result.data.map(async (item) => {
            let iconUrl = item.icon
            
            // Jika icon bukan URL lengkap, fetch dengan authentication
            if (item.icon && !item.icon.startsWith('http://') && !item.icon.startsWith('https://')) {
              const blobUrl = await this.fetchIconWithAuth(item.icon)
              iconUrl = blobUrl || item.icon
            }
            
            return {
              id: item.id,
              name: item.label.toLowerCase().replace(/\s+/g, '-'), // Generate name from label
              label: item.label,
              path: item.path,
              icon: iconUrl, // Icon blob URL atau original URL
              iconFilename: item.icon, // Simpan filename asli untuk reference
              roles: [], // Roles tidak ada di response, set default empty
              is_actived: true, // Default active
              is_deleted: false, // Default not deleted
              created_at: new Date(item.createdAt),
              updated_at: new Date(item.updatedAt),
              code: `MNU${String(item.id).padStart(6, '0')}` // Generate code from id
            }
          }))
          
          this.menus = menusData
          
          this.$message.success(result.message || 'Data menu berhasil dimuat')
        } else {
          throw new Error(result.message || 'Gagal memuat data menu')
        }
      } catch (error) {
        console.error('Error loading menus:', error)
        this.$message.error('Gagal memuat data menu: ' + error.message)
        // Fallback to empty array if API fails
        this.menus = []
      } finally {
        this.loading = false
      }
    },
    
    // Search & Filter
    handleSearch() {
      this.currentPage = 1
    },
    
    resetFilters() {
      this.searchQuery = ''
      this.statusFilter = ''
      this.currentPage = 1
    },
    
    // Sorting
    handleSort({ column, prop, order }) {
      if (order === 'ascending') {
        this.menus.sort((a, b) => {
          if (typeof a[prop] === 'string') {
            return a[prop].localeCompare(b[prop])
          }
          return a[prop] - b[prop]
        })
      } else if (order === 'descending') {
        this.menus.sort((a, b) => {
          if (typeof a[prop] === 'string') {
            return b[prop].localeCompare(a[prop])
          }
          return b[prop] - a[prop]
        })
      }
    },
    
    // Pagination
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    
    handleCurrentChange(val) {
      this.currentPage = val
    },
    
    // Modal Management
    showCreateModal() {
      this.isEditing = false
      this.resetForm()
      this.showModal = true
    },
    
    showEditModal(menu) {
      this.isEditing = true
      this.menuForm = { ...menu }
      
      // Set icon preview untuk edit mode
      // Icon sudah berupa blob URL dari loadMenus
      this.iconPreview = menu.icon || ''
      
      // Reset iconFile karena ini edit existing menu
      this.iconFile = null
      
      this.showModal = true
    },
    
    handleIconChange(file, fileList) {
      // file.raw is the actual File object
      const rawFile = file.raw
      
      // Validate file type
      const isImage = rawFile.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('File harus berupa gambar!')
        // Clear the upload
        this.$refs.iconUpload.clearFiles()
        return
      }
      
      // Validate file size (max 2MB)
      const isLt2M = rawFile.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Ukuran gambar tidak boleh lebih dari 2MB!')
        // Clear the upload
        this.$refs.iconUpload.clearFiles()
        return
      }
      
      // Store file reference
      this.iconFile = rawFile
      
      // Create preview URL
      const reader = new FileReader()
      reader.onload = (e) => {
        this.iconPreview = e.target.result
      }
      reader.readAsDataURL(rawFile)
    },
    
    resetForm() {
      this.menuForm = {
        id: null,
        name: '',
        label: '',
        path: '',
        icon: '',
        is_actived: true,
        is_deleted: false,
        code: ''
      }
      
      // Reset icon upload
      this.iconFile = null
      this.iconPreview = ''
      
      // Clear upload component
      if (this.$refs.iconUpload) {
        this.$refs.iconUpload.clearFiles()
      }
      
      if (this.$refs.menuForm) {
        this.$refs.menuForm.clearValidate()
      }
    },
    
    // Form Submission
    submitForm() {
      this.$refs.menuForm.validate((valid) => {
        if (valid) {
          // Validate icon file for create
          if (!this.isEditing && !this.iconFile) {
            this.$message.error('Icon wajib diupload')
            return
          }
          
          this.submitting = true
          
          if (this.isEditing) {
            this.updateMenu()
          } else {
            this.createMenu()
          }
        }
      })
    },
    
    async createMenu() {
      try {
        const token = this.getAuthToken()
        
        // Create FormData
        const formData = new FormData()
        formData.append('label', this.menuForm.label)
        formData.append('path', this.menuForm.path)
        
        // Append icon file if exists
        if (this.iconFile) {
          formData.append('iconFile', this.iconFile)
        }
        
        const response = await fetch('https://apidev-intranet.lan.go.id/api/menu', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
            // Note: Don't set Content-Type for FormData, browser will set it automatically with boundary
          },
          body: formData
        })
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const result = await response.json()
        
        if (result.status === 201 && result.data) {
          // Fetch icon dengan authentication untuk preview
          let iconUrl = result.data.icon
          if (result.data.icon && !result.data.icon.startsWith('http://') && !result.data.icon.startsWith('https://')) {
            const blobUrl = await this.fetchIconWithAuth(result.data.icon)
            iconUrl = blobUrl || result.data.icon
          }
          
          // Map API response to component data structure
          const newMenu = {
            id: result.data.id,
            name: result.data.label.toLowerCase().replace(/\s+/g, '-'),
            label: result.data.label,
            path: result.data.path,
            icon: iconUrl, // Icon blob URL
            iconFilename: result.data.icon, // Simpan filename asli
            is_actived: true,
            is_deleted: false,
            created_at: new Date(result.data.createdAt),
            updated_at: new Date(result.data.updatedAt),
            code: `MNU${String(result.data.id).padStart(6, '0')}`
          }
          
          // Add to menus list
          this.menus.unshift(newMenu)
          
          this.$message.success(result.message || 'Menu berhasil ditambahkan!')
          this.showModal = false
          this.resetForm()
        } else {
          throw new Error(result.message || 'Gagal menambahkan menu')
        }
      } catch (error) {
        console.error('Error creating menu:', error)
        this.$message.error('Gagal menambahkan menu: ' + error.message)
      } finally {
        this.submitting = false
      }
    },
    
    async updateMenu() {
      try {
        const token = this.getAuthToken()
        
        // Create FormData
        const formData = new FormData()
        formData.append('label', this.menuForm.label)
        formData.append('path', this.menuForm.path)
        
        // Append icon file if user uploaded new icon
        if (this.iconFile) {
          formData.append('iconFile', this.iconFile)
        }
        
        const response = await fetch(`https://apidev-intranet.lan.go.id/api/menu/${this.menuForm.id}`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`
            // Note: Don't set Content-Type for FormData, browser will set it automatically with boundary
          },
          body: formData
        })
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const result = await response.json()
        
        if (result.status === 200 || result.status === 201) {
          // Fetch icon dengan authentication jika ada icon baru
          let iconUrl = result.data.icon
          if (result.data.icon && !result.data.icon.startsWith('http://') && !result.data.icon.startsWith('https://')) {
            const blobUrl = await this.fetchIconWithAuth(result.data.icon)
            iconUrl = blobUrl || result.data.icon
          }
          
          // Update menu in list
          const index = this.menus.findIndex(m => m.id === this.menuForm.id)
          if (index !== -1) {
            // Cleanup old blob URL if exists
            if (this.menus[index].icon && this.menus[index].icon.startsWith('blob:')) {
              URL.revokeObjectURL(this.menus[index].icon)
            }
            
            // Update with new data
            this.menus[index] = {
              id: result.data.id,
              name: result.data.label.toLowerCase().replace(/\s+/g, '-'),
              label: result.data.label,
              path: result.data.path,
              icon: iconUrl, // Icon blob URL
              iconFilename: result.data.icon, // Simpan filename asli
              is_actived: this.menus[index].is_actived, // Preserve existing status
              is_deleted: this.menus[index].is_deleted,
              created_at: new Date(result.data.createdAt),
              updated_at: new Date(result.data.updatedAt),
              code: this.menus[index].code // Preserve existing code
            }
          }
          
          this.$message.success(result.message || 'Menu berhasil diperbarui!')
          this.showModal = false
          this.resetForm()
        } else {
          throw new Error(result.message || 'Gagal memperbarui menu')
        }
      } catch (error) {
        console.error('Error updating menu:', error)
        this.$message.error('Gagal memperbarui menu: ' + error.message)
      } finally {
        this.submitting = false
      }
    },
    
    // Delete Menu
    confirmDelete(menu) {
      this.$confirm(
        `Apakah Anda yakin ingin menghapus menu "${menu.label}"?`,
        'Konfirmasi Hapus',
        {
          confirmButtonText: 'Ya, Hapus',
          cancelButtonText: 'Batal',
          type: 'warning'
        }
      ).then(() => {
        this.deleteMenu(menu.id)
      }).catch(() => {
        this.$message.info('Penghapusan dibatalkan')
      })
    },
    
    async deleteMenu(menuId) {
      try {
        const token = this.getAuthToken()
        
        const response = await fetch(`https://apidev-intranet.lan.go.id/api/menu/${menuId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        const result = await response.json()
        
        if (result.status === 200) {
          // Remove menu from list
          const index = this.menus.findIndex(m => m.id === menuId)
          if (index !== -1) {
            // Cleanup blob URL if exists
            if (this.menus[index].icon && this.menus[index].icon.startsWith('blob:')) {
              URL.revokeObjectURL(this.menus[index].icon)
            }
            
            // Remove from array
            this.menus.splice(index, 1)
          }
          
          this.$message.success(result.message || 'Menu berhasil dihapus!')
        } else {
          throw new Error(result.message || 'Gagal menghapus menu')
        }
      } catch (error) {
        console.error('Error deleting menu:', error)
        this.$message.error('Gagal menghapus menu: ' + error.message)
      }
    },
    
    // Utility Methods
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('id-ID', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    
    generateRandomString(length) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let result = ''
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return result
    },
    
    // Get icon URL for API icons with token authentication
    getIconUrl(icon) {
      if (!icon) {
        return ''
      }
      
      // Jika icon sudah berupa URL lengkap, return as is
      if (icon.startsWith('http://') || icon.startsWith('https://')) {
        return icon
      }
      
      // Jika icon berupa filename, konstruksi URL dengan API endpoint
      // Note: Karena perlu token, kita akan load icon via fetch di mounted/loadMenus
      return `https://apidev-intranet.lan.go.id/api/menu/files/${icon}`
    },
    
    // Fetch icon with token authentication
    async fetchIconWithAuth(iconFilename) {
      try {
        const token = this.getAuthToken()
        const response = await fetch(`https://apidev-intranet.lan.go.id/api/menu/files/${iconFilename}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        
        // Convert response to blob and create object URL
        const blob = await response.blob()
        return URL.createObjectURL(blob)
      } catch (error) {
        console.error('Error fetching icon:', error)
        return null
      }
    },
    
    // Handle icon load error
    handleIconError(event) {
      // Fallback to default icon jika image gagal load
      event.target.style.display = 'none'
      const iconElement = document.createElement('i')
      iconElement.className = 'el-icon-menu'
      iconElement.style.fontSize = '18px'
      iconElement.style.color = '#999'
      event.target.parentNode.appendChild(iconElement)
    },
  }
}
</script>

<style scoped>
/* Page Layout */
.menu-management {
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* Header Section */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 32px;
  border-radius: 16px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.header-content {
  color: white;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title i {
  font-size: 36px;
}

.page-subtitle {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
  font-weight: 300;
}

/* Search Section */
.search-section {
  background: white;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
}

.search-controls {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.search-input {
  min-width: 300px;
  flex: 1;
}

.filter-select {
  min-width: 180px;
}

/* Table Section */
.table-section {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
}

/* Custom Table Styling */
.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table th {
  background-color: #f8fafc !important;
  font-weight: 600;
  color: #2d3748;
  border-bottom: 2px solid #e2e8f0;
}

.el-table td {
  padding: 16px 0;
}

.el-table .el-table__row:hover > td {
  background-color: #f7fafc !important;
}

/* Status Tags */
.el-tag {
  font-weight: 500;
  border-radius: 6px;
  padding: 4px 8px;
}

/* Pagination */
.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

/* Modal Styling */
.el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
}

.el-dialog__title {
  color: white !important;
  font-weight: 600;
  font-size: 20px;
}

.el-dialog__body {
  padding: 32px 24px;
}

.el-dialog__footer {
  padding: 20px 24px;
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

/* Form Styling */
.el-form-item {
  margin-bottom: 24px;
}

.el-form-item__label {
  font-weight: 600;
  color: #2d3748;
}

.el-input__inner,
.el-select {
  border-radius: 8px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}

.el-input__inner:focus,
.el-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Button Styling */
.el-button {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.el-button--danger {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: none;
  color: white;
}

.el-button--danger:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(238, 90, 82, 0.3);
}

.el-button.is-loading {
  pointer-events: none;
}

/* Action Buttons in Table */
.el-table .el-button--mini {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 6px;
}

/* Switch Styling */
.el-switch.is-checked .el-switch__core {
  background-color: #667eea;
  border-color: #667eea;
}

/* Loading */
.el-loading-spinner {
  font-size: 32px;
}

.el-loading-text {
  color: #667eea;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 768px) {
  .menu-management {
    padding: 16px;
  }
  
  .page-header {
    flex-direction: column;
    gap: 20px;
    text-align: center;
    padding: 24px;
  }
  
  .search-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .search-input,
  .filter-select {
    min-width: auto;
    width: 100%;
  }
  
  .table-section {
    padding: 16px;
    overflow-x: auto;
  }
  
  .el-table {
    min-width: 800px;
  }
  
  .pagination-wrapper {
    margin-top: 16px;
    padding-top: 16px;
  }
  
  .el-dialog {
    width: 95% !important;
    margin: 20px auto !important;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 24px;
  }
  
  .page-title i {
    font-size: 28px;
  }
  
  .search-section,
  .table-section {
    padding: 16px;
  }
  
  .el-dialog__body {
    padding: 24px 16px;
  }
}

/* Animation */
.menu-management {
  animation: fadeIn 0.6s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}

/* Icon Animations */
.el-table .el-button i {
  transition: transform 0.2s ease;
}

.el-table .el-button:hover i {
  transform: scale(1.1);
}

/* Form Focus Effects */
.el-input.is-focus .el-input__inner {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

/* Status Indicator Animations */
.el-tag {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.7);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(102, 126, 234, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0);
  }
}

.el-tag--success {
  animation: pulse-success 2s infinite;
}

@keyframes pulse-success {
  0% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0.7);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(103, 194, 58, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0);
  }
}

.el-tag--danger {
  animation: pulse-danger 2s infinite;
}

@keyframes pulse-danger {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.7);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(245, 108, 108, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
  }
}

/* Role Tags Styling */
.roles-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}

.role-tag {
  margin: 2px;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
}

/* Form Help Text */
.form-help-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  line-height: 1.4;
}

/* Multiple Select Styling */
.el-select--multiple .el-select__tags {
  max-height: 100px;
  overflow-y: auto;
}

.el-select--multiple .el-tag--info {
  background-color: #667eea;
  border-color: #667eea;
  color: white;
}

.el-select--multiple .el-tag--info .el-tag__close {
  color: white;
}

.el-select--multiple .el-tag--info .el-tag__close:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

/* Icon Uploader Styling */
.icon-uploader {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.icon-preview {
  width: 120px;
  height: 120px;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #f5f7fa;
  padding: 10px;
}

.icon-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.el-upload__tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>